/* eslint-disable @next/next/no-img-element */
import React, { useState } from "react";
import Link from "next/link";
import { useRouter } from "next/router";

import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import Person2OutlinedIcon from "@mui/icons-material/Person2Outlined";
import MenuIcon from "@mui/icons-material/Menu";
import PeopleAlt from "@mui/icons-material/PeopleAlt";

const Sidebar = () => {
  const { pathname } = useRouter();
  const [navActive, setnavActive] = useState(false);

  return (
    <>
      <div className="sidebar-open-btn" onClick={() => setnavActive(!navActive)}>
        <MenuIcon />
      </div>
      <div className={`sidebar-open ${navActive ? "sidebar-active" : ""}`}>
        <div className="bg-dark-mob" onClick={() => setnavActive(false)} />
        <div className="wrapper">
          <Link href="/">
            <div className="logo">
              <img src="/logo_primary.png" alt="logo" />
            </div>
          </Link>
          <div className="menu">
            <div className="section">
              <Link href="/dashboard">
                <div className={`tab ${pathname.includes("/dashboard") ? "tab-active" : ""}`}>
                  <div className="icon">
                    <DashboardOutlinedIcon />
                  </div>
                  <p>My canvas</p>
                </div>
              </Link>
              <Link href="/shared_with_me">
                <div className={`tab ${pathname === "/shared_with_me" ? "tab-active" : ""}`}>
                  <div className="icon">
                    <PeopleAlt />
                  </div>
                  <p>Shared with me</p>
                </div>
              </Link>
              <Link href="/profile">
                <div className={`tab ${pathname === "/profile" ? "tab-active" : ""}`}>
                  <div className="icon">
                    <Person2OutlinedIcon />
                  </div>
                  <p>My profile</p>
                </div>
              </Link>
              {/* <Link href="/boards-team" passHref>
              <a href="/boards-team" className={`tab ${pathname === "/boards-team" ? "tab-active" : ""}`}>
                <div className="icon">
                  <CoPresentIcon />
                </div>
                <p>Boards in this team</p>
              </a>
            </Link>
            <Link href="/boards-team" passHref>
              <a href="/boards-team" className={`tab ${pathname === "/boards-team" ? "tab-active" : ""}`}>
                <div className="icon">
                  <div className="dot" />
                  <PublicIcon />
                </div>
                <p>Miroverse</p>
              </a>
            </Link> */}
            </div>

            {/* <div className="section">
            <InputSelect label="Website team" options={["4 users", "2 users", "1 user"]} />
          </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
